/* jQuery anchor link */
jQuery(document).ready(function(){
    $('#check-menu').click(function(){
        $("body, html").toggleClass('hidden');
    });
    OpenBox({
        wrap: '.open-wrap',
        link: '.open-btn',
        box: '.open-drop',
        openClass: 'open',
    });
    openClose();
    openClose02();

    $('.simplebox').simplebox();

    $('.help-box').tabs();

    moment.locale('en');
    moment.updateLocale('en', {
        months : [
            "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
        ],
        monthsShort : [
            "Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"
        ]
    })
    $('#picker').daterangepicker({
        ranges: {
            'Сегодня': [moment(), moment()],
            'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Последние 7 дней': [moment().subtract(6, 'days'), moment()],
            'Последние 30 дней': [moment().subtract(29, 'days'), moment()],
            'Этот месяц': [moment().startOf('month'), moment().endOf('month')],
            'Этот год': [moment().startOf('year'), moment().endOf('year')],
            'Прошлый год': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
            'Все время': [moment().subtract(5, 'year').startOf('year'), moment()]
        },
        "locale": {
            "format": "DD MMMM YYYY",
            "separator": " - ",
            "applyLabel": "Сохранить",
            "cancelLabel": "Отмена",
            "fromLabel": "From",
            "toLabel": "To",
            "customRangeLabel": "Другой период",
            "weekLabel": "W",
            "daysOfWeek": [
                "Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"
            ],
            "monthNames": [
                "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
            ],
            "firstDay": 1
        },
        "autoUpdateInput": false,
        "alwaysShowCalendars": true,
        "startDate": moment().subtract(10, 'days'),
        "endDate": moment(),
        "opens": "left"
    }, function(start, end, label) {
        $(this.element).text(label + ': ' + start.format('DD MMM') + ' - ' + end.format('DD MMM'));
    });

    initCharts();
});

function initCharts() {
    am4core.useTheme(am4themes_animated);

    var chart = am4core.create("chartdiv", am4charts.XYChart);

    var chartData = [ {
        "dateString": "10\nСен",
        "title": "10 сентября 2019",
        "firstwebsite": Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "11\nСен",
        "title": "11 сентября 2019",
        "firstwebsite": Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "12\nСен",
        "title": "12 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "13\nСен",
        "title": "13 сентября 2019",
        "firstwebsite": Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "14\nСен",
        "title": "14 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "15\nСен",
        "title": "15 сентября 2019",
        "firstwebsite": Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "16\nСен",
        "title": "16 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "17\nСен",
        "title": "17 сентября 2019",
        "firstwebsite": Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "18\nСен",
        "title": "18 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    }, {
        "dateString": "19\nСен",
        "title": "19 сентября 2019",
        "firstwebsite": Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    },{
        "dateString": "20\nСен",
        "title": "20 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    },{
        "dateString": "21\nСен",
        "title": "21 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    },{
        "dateString": "22\nСен",
        "title": "22 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    },{
        "dateString": "23\nСен",
        "title": "23 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    },{
        "dateString": "24\nСен",
        "title": "24 сентября 2019",
        "firstwebsite":  Math.floor(Math.random() * 11 + 3),
        "secondwebsite": Math.floor(Math.random() * 20 + 4)
    } ];

    var chartKeys = [
        {
            field: "firstwebsite",
            name: "firstwebsite.ru",
            color: "rgb(25, 197, 139)"
        },
        {
            field: "secondwebsite",
            name: "secondwebsite.ru",
            color: "rgb(88, 130, 253)"
        }
    ]

    $.each(chartData, function(i, data){
    	data.total = 0;
    	$.each(data, function(key, value){
    		if(["dateString", "title", "total"].indexOf(key) === -1) {
                data.total += value;
            }
    	});
    });

    var tooltipHTML = '<div>' +
        '<strong class="title">{title}</strong>'+
        '<dl><dt>Всего:</dt> <dd>{total} кликов</dd></dl>';

    $.each(chartKeys, function(i, val){
        tooltipHTML += '<dl><dt><span style="display: inline-block; background-color: ' + val.color + '">&nbsp;&nbsp;&nbsp;</span> ' + val.name + '</dt> <dd>{' + val.field + '} кликов</dd></dl>';
    });

    tooltipHTML += '</div>'

    chart.data = chartData;

    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "dateString";
    categoryAxis.renderer.grid.template.strokeWidth = 0;
    categoryAxis.renderer.labels.template.fill = am4core.color("rgb(154, 165, 170)");
    categoryAxis.renderer.labels.template.fontSize = 13;
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.cursorTooltipEnabled = false;

    var  valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.labels.template.fill = am4core.color("rgb(154, 165, 170)");
    valueAxis.renderer.labels.template.fontSize = 13;
    valueAxis.cursorTooltipEnabled = false;

    function createSeries(field, name, stacked, color, last) {
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "dateString";
        series.name = name;
        series.fill = am4core.color(color);
        series.strokeWidth = 1;
        series.stroke = am4core.color("#fff");
        series.stacked = stacked;
        series.columns.template.width = 15;
        if(last) {
            var bullets = new am4charts.CircleBullet();
            bullets.strokeWidth = 3;
            bullets.fill = am4core.color("#999");
            bullets.stroke = am4core.color("#fff");
            bullets.opacity = 0;
            bullets.scale = 0;
            bullets.showOnInit = false;
            bullets.appeared = true;

            // Create hover state
            var hoverState = bullets.states.create("hover");
            hoverState.properties.scale = 1;
            series.bullets.push(bullets);
            var columnTemplate = series.columns.template;
            columnTemplate.width = 15;
            columnTemplate.column.cornerRadiusTopLeft = 5;
            columnTemplate.column.cornerRadiusTopRight = 5;

            series.tooltipHTML = tooltipHTML;

            series.tooltip.pointerOrientation = "horizontal";
            series.tooltip.getFillFromObject = false;
            series.tooltip.label.fill = am4core.color("rgb(56, 71, 83)");
            series.tooltip.background.fill = am4core.color("#fff");
            series.tooltip.background.fillOpacity = 1;
            var shadow = series.tooltip.background.filters.getIndex(0);
            shadow.dx = 0;
            shadow.dy = 0;
            shadow.blur = 15;
            shadow.color = am4core.color("#ccc");
        }
    }

    $.each(chartKeys, function(i, key){
        createSeries(key.field, key.name, i !== 0, key.color, i === chartKeys.length - 1);
    });

    chart.legend = new am4charts.Legend();

    var markerTemplate = chart.legend.markers.template;
    markerTemplate.width = 12;
    markerTemplate.height = 12;

    chart.cursor = new am4charts.XYCursor();
}

function OpenBox(obj){
    $(obj.wrap).each(function(){
        var hold = $(this);
        var link = hold.find(obj.link);
        var box = hold.find(obj.box);
        var w = obj.w;
        var close = hold.find(obj.close);

        link.click(function(){
            $(obj.wrap).not(hold).removeClass(obj.openClass);
            if (!hold.hasClass(obj.openClass)) {
                hold.addClass(obj.openClass);
            }
            else {
                hold.removeClass(obj.openClass);
            }
            return false;
        });

        hold.hover(function(){
            $(this).addClass('hovering');
        }, function(){
            $(this).removeClass('hovering');
        });

        $("body").click(function(){
            if (!hold.hasClass('hovering')) {
                hold.removeClass(obj.openClass);
            }
        });
        close.click(function(){
            hold.removeClass(obj.openClass);

            return false;
        });

        jQuery(document).bind('touchstart mousedown', function(e){
            if(!(jQuery(e.target).parents().index(hold) != -1 || jQuery(e.target).index(hold) != -1)){
                hold.removeClass(obj.openClass);
            }
        });
    });
}

function openClose() {
    var wrap = $('.drop-wrap').each(function () {
        var boxed = $(this);
        var link = boxed.find('.drop-btn');
        var boxOpen = boxed.find('.drop-box');

        boxOpen.css('display', 'none');
        boxed.removeClass('open-close')
        link.on('click', function (e) {
            if (!boxed.hasClass('open-close')) {
                boxed.addClass('open-close');
                boxOpen.slideUp(0).slideDown(400);
            }
            else {
                boxOpen.slideUp(400, function () {
                    boxed.removeClass('open-close');
                });
            }
            return false;
        });
    });
}
function openClose02() {
    var wrap = $('.season-row').each(function () {
        var boxed = $(this);
        var link = boxed.find('.arrow-icon, .title-season');
        var boxOpen = boxed.find('.body-season');

        boxOpen.css('display', 'none');
        boxed.removeClass('open-season')
        link.on('click', function (e) {
            if (!boxed.hasClass('open-season')) {
                boxed.addClass('open-season');
                boxOpen.slideUp(0).slideDown(400);
            }
            else {
                boxOpen.slideUp(400, function () {
                    boxed.removeClass('open-season');
                });
            }
            return false;
        });
    });
}
